export default __webpack_public_path__ + "static/media/img_character_joy_empty_soon.2bb129d8.svg";